module.exports = __webpack_public_path__ + "static/media/img_wear-remove-04.3c5d18ef.svg";